import * as React from 'react';
import * as moment from 'moment'
import SubscriptionService from '../services/SubscriptionService';
import SiteCoreService from '../../core/services/SiteCoreService';
import SiteCoreHelper from '../../core/helpers/SiteCoreHelper';
import Subscription from '../models/Subscription';
import { TextField, Grid, Button, Paper, Typography, Chip } from '@material-ui/core';
import SnackbarService from '../../core/services/SnackbarService'
import CopyIcon from '@material-ui/icons/ContentCopy';
import MailIcon from '@material-ui/icons/Mail';
import {identity} from '../../core/auth/identityAuth';
import Loading from '../../shared/components/loading/Loading';
import {defaultProvider} from '../../../constants'
import Link from 'src/modules/shared/components/Link';
import AreYouSureModal from 'src/modules/shared/dataSharing/AreYouSureModal';
import RequestService from '../../core/services/SubscriptionRequestService';
import { ISitecoreAsset } from "../../shared/models/SitecoreAsset";
import { SubscriptionStatusIds } from "../../shared/constants";

const subscriptionService = SubscriptionService.Instance;
const snackbarService = SnackbarService.Instance;
const siteCoreService = SiteCoreService.Instance;
const requestService = RequestService.Instance;

interface IState {
  loading: boolean
  apiKey: string | null
  subscription: Subscription
  termsAndConditionsUrl: string
  cancelSubscription: boolean
  cancelling: boolean
}

class ConsumerAssetGeneralSettings extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      loading: true,
      apiKey: '',
      subscription: new Subscription(),
      termsAndConditionsUrl: '',
      cancelSubscription: false,
      cancelling: false,
    };
  }

  public async componentDidMount() {
    const [subscription, siteCoreAsset]: [Subscription, ISitecoreAsset | undefined] = await Promise.all([
      subscriptionService.getSubscription(this.props.assetId, this.props.environment),
      siteCoreService.getSiteCoreAsset(this.props.assetId)
    ]);

    const apiKey = subscription.state.id === SubscriptionStatusIds.Active ?
      await subscriptionService.getApiKey(subscription.id)
      : null;

    this.setState({
      subscription,
      apiKey,
      loading: false,
      termsAndConditionsUrl: SiteCoreHelper.getTermsAndConditionsUrl(siteCoreAsset)
    });
  }

  public textToClipboard = (text: string) => {
    const el = document.createElement('textarea');
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    snackbarService.showSnackbar('success', 'Copied ApiKey to clipboard')
  }

  public render() {
    return (
      <div>
        <Typography color="textSecondary" gutterBottom={true}>
          Subscription &nbsp; &rang; Info
        </Typography>
        {this.state.loading &&
          <Loading />
        }
        {!this.state.loading &&
          <Paper className="padding-24">
            {this.state.subscription.subscriptionProvider !== defaultProvider &&
              <div className="padding-bottom-24">
                <Chip className='full-width' label={"This subscription is linked to external service provider " + this.state.subscription.subscriptionProvider+". Some functionality is limited."} />
              </div>
            }
          <Grid container={true} spacing={24}>
            <Grid item={true}>
              <Link url={this.state.termsAndConditionsUrl}>
                Click here to read the terms and conditions for this subscription.
              </Link>
            </Grid>
          </Grid>
            <Grid container={true} spacing={24}>
              <Grid item={true} xs={3}>
                <TextField
                  id="subscriptionStatus"
                  label="Subscription status"
                  disabled
                  value={this.state.subscription.state.name}
                  margin='normal'
                  fullWidth
                  InputLabelProps={{shrink: true}}
                />
              </Grid>
              <Grid item={true} xs={3}>
                <TextField
                  id="subscriptionStatus"
                  label="Last updated on"
                  disabled
                  value={moment(this.state.subscription.updatedOn).format('YYYY-MM-DD')}
                  margin='normal'
                  fullWidth
                  InputLabelProps={{shrink: true}}
                />
              </Grid>
              <Grid item={true} xs={3}>
                <TextField
                  id="subscriptionActivation"
                  label="Activated on"
                  disabled
                  value={moment(this.state.subscription.activatedOn).format('YYYY-MM-DD')}
                  margin='normal'
                  fullWidth
                  InputLabelProps={{shrink: true}}
                />
              </Grid>
              <Grid item={true} xs={3}>
                <TextField
                  id="subscriptionProvider"
                  label="Subscription Provider"
                  disabled
                  value={this.state.subscription.subscriptionProvider}
                  margin='normal'
                  fullWidth
                  InputLabelProps={{shrink: true}}
                />
              </Grid>
              <Grid item={true} xs={12}>
                <Grid container>
                  <Grid item={true} xs={7} md={6} lg={4}>
                    <TextField
                      id="apiKey"
                      label="apiKey"
                      disabled
                      value={this.state.apiKey || ''}
                      fullWidth
                      margin='normal'
                      InputLabelProps={{shrink: true}}
                    />
                  </Grid>
                  <Grid item={true} xs={5} md={6} lg={8}>
                    {this.state.apiKey &&
                      <Button
                        variant="fab"
                        onClick={() => this.textToClipboard(this.state.apiKey || '')}
                        color="secondary"
                        mini={true}
                      >
                        <CopyIcon />
                      </Button>
                    }
                    <span className="margin-right-8" />
                    {identity.email && this.state.apiKey &&
                      <Button
                        variant="fab"
                        href={'mailto:' + identity.email + '?subject=[ApiKey] ' + this.state.subscription.product.asset.name + ' ' + this.state.subscription.environment.name + '&body=' + this.state.apiKey}
                        color="secondary"
                        mini={true}
                      >
                        <MailIcon />
                      </Button>
                    }
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="remark"
                  label="Remark"
                  disabled
                  value={this.state.subscription.remark}
                  fullWidth
                  margin='normal'
                  InputLabelProps={{shrink: true}}
                />
              </Grid>
            </Grid>
            {this.state.subscription.roles.length ?
              <Grid container={true} spacing={24}>
                <Grid item={true}>
                  <div><Typography variant="caption" gutterBottom={true}>Roles</Typography></div>
                  <Grid container spacing={16} alignItems='center'>
                    {this.state.subscription.roles.map((role: any) =>
                      <Grid item key={role.id}><Chip label={role.name} /></Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid> : null}
            <Grid container={true} spacing={24}>
              <br />
            {/* TODO: Remove "false &&" to enable cancelling of subscriptions. */}
            {false && this.state.subscription.state.id === 4 && <Grid item={true}>
              <Button
                  variant="contained"
                  color="primary"
                  onClick={this.startCancel}
                  disabled={this.state.cancelling}
                  style={{marginTop: 4}}
                >
                  Cancel
              </Button>
            </Grid>}
          </Grid>
          <AreYouSureModal 
            onClose={this.stopCancel}
            onConfirm={this.cancelSubscription}
            message="Are you sure you wish to cancel your subscription?"
            open={this.state.cancelSubscription}
          />
          </Paper>
        }
      </div>
    );
  }

  public cancelSubscription = async () => {
    this.stopCancel();
    this.setState({ cancelling: true });
    await requestService.cancelSubscription(this.state.subscription.id);
    this.componentDidMount();
  }

  public startCancel = () => {
    this.setState({ cancelSubscription: true });
  }

  public stopCancel = () => {
    this.setState({ cancelSubscription: false });
  }
}

export default ConsumerAssetGeneralSettings



// WEBPACK FOOTER //
// ./src/modules/consumer/pages/ConsumerAssetGeneralSettings.tsx